import styled from "styled-components";

const MyGamovoreLayout = styled.section`
  display: flex;
  min-width: 100%;
  flex-direction: column;
  justify-content: space-evenly;
`;

export default MyGamovoreLayout;
